import { React, useState, useEffect } from "react";
import { connect } from "react-redux";
import { MdCall, MdAccessTime, MdOutlineEmail } from "react-icons/md";
import { Link, useHistory } from "react-router-dom";
import Labels from "../../services/apiLabels";
import { POST } from "../../constant/apiMethods";
import { CREATE_SUBSCRIPTION } from "../../constant";
import BrandLogo from "../BrandLogo/BrandLogo";
import "./style.css";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";

const trim = (str) => (str || "").trim();

export const Footer = ({ create_subscription, subscriptionSuccessAt }) => {
  const { feedback } = useContext(FeedbackContext);
  const home_page = feedback.home_page;
  const history = useHistory();
  const [email, setemail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (subscriptionSuccessAt) {
      setemail("");
      setSubmitting(false);
    }
  }, [subscriptionSuccessAt]);

  const subscribe_me = (event) => {
    if (event) event.preventDefault();
    if (submitting) return;
    const nextEmail = email.trim();
    if (!nextEmail) return;
    setSubmitting(true);
    create_subscription({ email: nextEmail }, () => setSubmitting(false));
  };

  const exploreLinks = [
    { to: "/aboutus", label: home_page.About_us },
    { to: "/contactus", label: home_page.contact_us },
    { to: "/faqs", label: home_page.FAQs },
  ];

  const legalLinks = [
    { to: "/privacypolicy", label: home_page.Privacy_Policy },
    { to: "/terms", label: home_page.Terms_conditions },
    { to: "/requridocuments", label: home_page.Required_documents },
  ];

  return (
    <div className="footer-v2">
      <div className="footer-v2__main">
        <div className="footer-v2__inner">
          <div className="footer-v2__grid">
            <div className="footer-v2__brand">
              <BrandLogo
                variant="light"
                onClick={() => history.push("/")}
                className="footer-v2__logo"
              />
              <h2 className="footer-v2__headline">{trim(home_page.any_question)}</h2>
              <p className="footer-v2__desc">{trim(home_page.any_question_desp)}</p>
              <div className="footer-v2__contact">
                <span className="footer-v2__contact-item">
                  <MdCall size={17} aria-hidden />
                  {trim(home_page.call_number)}
                </span>
                <span className="footer-v2__contact-item">
                  <MdAccessTime size={17} aria-hidden />
                  {trim(home_page.call_time)}
                </span>
              </div>
            </div>

            <nav className="footer-v2__col" aria-label="Explore">
              <h3 className="footer-v2__col-title">Explore</h3>
              <ul className="footer-v2__links foter_list list_wrap">
                {exploreLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="footer-v2__link link">
                      {trim(link.label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <nav className="footer-v2__col" aria-label="Legal">
              <h3 className="footer-v2__col-title">Legal</h3>
              <ul className="footer-v2__links foter_list list_wrap">
                {legalLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="footer-v2__link link">
                      {trim(link.label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="footer-v2__newsletter footer-v2__newsletter--card">
              <h3 className="footer-v2__newsletter-title">{trim(home_page.Subscribe_text)}</h3>
              <p className="footer-v2__newsletter-desc">{trim(home_page.Subscribe_desp)}</p>
              <form className="footer-v2__subscribe-form" onSubmit={subscribe_me}>
                <label className="footer-v2__sr-only" htmlFor="footer-subscribe-email">
                  Email address
                </label>
                <div className="footer-v2__field">
                  <span className="footer-v2__field-icon" aria-hidden>
                    <MdOutlineEmail size={20} />
                  </span>
                  <input
                    id="footer-subscribe-email"
                    onChange={(e) => setemail(e.target.value)}
                    value={email}
                    className="footer-v2__input"
                    type="email"
                    required
                    placeholder={trim(home_page.Subscribe_placeholder)}
                  />
                </div>
                <button
                  type="submit"
                  name="CTAButton"
                  className="footer-v2__submit"
                  disabled={submitting}
                >
                  {submitting
                    ? "Subscribing…"
                    : trim(home_page.Subscribe_button_text)}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  subscriptionSuccessAt: state.product.subscriptionSuccessAt,
});

const mapDispatchToProps = (dispatch) => ({
  create_subscription: (data, callBack) =>
    dispatch({
      type: CREATE_SUBSCRIPTION,
      payload: {
        type: CREATE_SUBSCRIPTION,
        label: Labels.createSubscription,
        method: POST,
        data,
        hideOverlayLoader: true,
        callBack,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
